export default function() {
    
    const filterTrigger = document.querySelector('.wrapper-product-list__facet-trigger');
    const filterClose = document.querySelector('.close-filters');
    const facetList = document.querySelector('.wrapper-product-list__facet');

console.log('filterClose', filterClose);

    if ( filterTrigger && facetList ) {
        filterTrigger.addEventListener( 'click', function(e) {
            e.preventDefault();
            facetList.classList.add('open');
        });
    }
    if ( filterClose && facetList ) {
        filterClose.addEventListener( 'click', function(e) {
            e.preventDefault();
            facetList.classList.remove('open');
        });
    }

}

